import { h } from '@atomify/jsx';
import { MapTheme, MapThemeExtension } from '@bpd-library/types';

export const extendMapTheme = (...mapThemes: (MapTheme | MapThemeExtension)[]): MapTheme => {
    const newTheme: MapTheme = {
        polygon: { settings: [] },
        pointer: { settings: [], cluster: (total) => <span>{total}</span> },
    };

    mapThemes.forEach(({ polygon, pointer }) => {
        polygon?.settings.length && newTheme.polygon?.settings?.push(...polygon.settings);
        pointer?.settings.length && newTheme.pointer?.settings?.push(...pointer.settings);
        if (pointer?.cluster && newTheme.pointer) {
            newTheme.pointer.cluster = pointer.cluster;
        }
    });

    return newTheme;
};
